"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrugPanelItem_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var SurgeryDrug_1 = require("./SurgeryDrug");
var SurgeryDrugDosageType_1 = require("./SurgeryDrugDosageType");
var SurgeryGas_1 = require("./SurgeryGas");
var DrugPanelItem_Factory = /** @class */ (function () {
    function DrugPanelItem_Factory() {
    }
    DrugPanelItem_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Dose: model.Dose,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            SurgerDrugRecord: SurgeryDrug_1.SurgeryDrug_Factory.CreateIncoming(model.SurgerDrugRecord),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryDrugDosageTypeRecord: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateIncoming(model.SurgeryDrugDosageTypeRecord),
            SurgeryDrugId: model.SurgeryDrugId,
            SurgeryGasId: model.SurgeryGasId,
            SurgeryGasRecord: SurgeryGas_1.SurgeryGas_Factory.CreateIncoming(model.SurgeryGasRecord),
            SurgeryVitalsId: model.SurgeryVitalsId,
            Time: Date_Factory_1.Date_Factory.CreateIncoming(model.Time),
        };
        return result;
    };
    DrugPanelItem_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Dose: model.Dose,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            SurgerDrugRecord: SurgeryDrug_1.SurgeryDrug_Factory.CreateOutgoing(model.SurgerDrugRecord),
            SurgeryDrugDosageTypeId: model.SurgeryDrugDosageTypeId,
            SurgeryDrugDosageTypeRecord: SurgeryDrugDosageType_1.SurgeryDrugDosageType_Factory.CreateOutgoing(model.SurgeryDrugDosageTypeRecord),
            SurgeryDrugId: model.SurgeryDrugId,
            SurgeryGasId: model.SurgeryGasId,
            SurgeryGasRecord: SurgeryGas_1.SurgeryGas_Factory.CreateOutgoing(model.SurgeryGasRecord),
            SurgeryVitalsId: model.SurgeryVitalsId,
            Time: Date_Factory_1.Date_Factory.CreateOutgoing(model.Time),
        };
        return result;
    };
    return DrugPanelItem_Factory;
}());
exports.DrugPanelItem_Factory = DrugPanelItem_Factory;
